<template>
  <span>
    <span
      v-for="(deal_plan, i) in deal.unique_plan_types"
      :key="deal_plan.id"
    >
      <span
        v-if="deal_plan[0] === 'Lifetime Deal' || deal_plan[0] === 'One Time Purchase'"
        class="deal-plan-type"
      >Lifetime deal</span>
      <span
        v-else-if="deal_plan[0] === 'Freebie'"
        class="deal-plan-type"
      >Freebie</span>
      <span
        v-else-if="deal_plan[0] === 'Subscription'"
        class="deal-plan-type"
      >Subscription</span>
      <span
        v-else-if="deal_plan[0] === 'Digital Download'"
        class="deal-plan-type"
      >Digital download</span>
      <span
        v-else-if="deal_plan[0] === 'Limited License'"
        class="deal-plan-type"
      >
        {{ deal_plan[2] }} {{ deal_plan[1].toUpperCase() }} DEAL
      </span>

      <span
        v-if="i !== deal.unique_plan_types.length - 1"
        class="deal-plan-type"
      >&#183;</span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    deal: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
